import styled from 'styled-components';

import { Button } from '@sternum/ui';
import { Colors } from '@sternum/web/components/theme/constants';
import { ct } from '@sternum/web/utils/theme';

export const ButtonStyled = styled(Button)`
  color: ${ct({ Dark: Colors.BrandBlue, Light: Colors.BrandBlue })};
  font-size: 12px;
`;
